module.exports = __webpack_public_path__ + "img/frolicking fairies.48a7b0b5.png";